'use client';

import { ReactNode } from 'react';
import { Drawer, DrawerContent } from '@sib/ui';

interface NavDrawerProps {
  children: ReactNode;
  onNavOpen: (isOpen: boolean) => void;
  isOpen: boolean;
}

export const NavDrawer = ({ children, onNavOpen, isOpen }: NavDrawerProps) => {
  return (
    <Drawer direction="left" open={isOpen} onOpenChange={onNavOpen}>
      <DrawerContent className="fixed top-[66px] bottom-0 z-50 mt-0 flex rounded-none outline-none sm:hidden">
        <div className="flex h-full w-full grow flex-col overflow-y-auto bg-white p-4">
          {children}
        </div>
      </DrawerContent>
    </Drawer>
  );
};
